/**
 * created by hezq on 2019-11-21
 *
 * description: 日期工具类
 *
 */

/**
 * description: 将日期格式化成指定格式的字符串
 * @param {String} fmt 目标字符串格式，支持的字符有：y,M,d,q,w,H,h,m,S，默认：yyyy-MM-dd HH:mm:ss
 * @return {String} 返回格式化后的日期字符串
 * 
 * created by hezq on 2019-11-21
 */
Date.prototype.format = function(fmt) {
	let type = Object.prototype.toString.call(this);
	
	// 如果不是Date类型,返回空字符串
	if (type === "[object Date]") {
		// 格式如果不传,默认yyyy-MM-dd HH:mm:ss
		fmt = fmt || 'yyyy-MM-dd HH:mm:ss';
		
		let obj = {
			'y': this.getFullYear(), // 年份，注意必须用getFullYear
			'M': this.getMonth() + 1, // 月份，注意是从0-11
			'd': this.getDate(), // 日期
			'q': Math.floor((this.getMonth() + 3) / 3), // 季度
			'w': this.getDay(), // 星期，注意是0-6
			'H': this.getHours(), // 24小时制
			'h': this.getHours() % 12 === 0 ? 12 : this.getHours() % 12, // 12小时制
			'm': this.getMinutes(), // 分钟
			's': this.getSeconds(), // 秒
			'S': this.getMilliseconds() // 毫秒
		};
		
		// 星期枚举
		const week = ['天', '一', '二', '三', '四', '五', '六'];
		// 通过指定格式,替代出格式化后的字符串
		for (let i in obj) {
			fmt = fmt.replace(new RegExp(i + '+', 'g'), function(m) {
				let val = String(obj[i]);
		
				if (i === 'w') {
					return (m.length > 2 ? '星期' : '周') + week[val];
				}
				for (let j = 0, len = val.length; j < m.length - len; j++) {
					val = '0' + val;
				}
				return m.length === 1 ? val : val.substring(val.length - m.length);
			});
		}
		
		return fmt;
	}
	
	return this;
};

/**
 * description: 将一个日期格式化成友好格式，比如，1分钟以内的返回“刚刚”，当天的返回时分，当年的返回月日，否则，返回年月日
 * @return {String} 返回格式化后的日期字符串
 * 
 * created by hezq on 2019-11-21
 */
Date.prototype.formatToFriendly = function() {
	// 当前时间
	let now = new Date();
	
	// 1分钟以内视作“刚刚”
	if (now.getTime() - this.getTime() < 60 * 1000) {
		return '刚刚';
	} 
	
	let temp = this.format('yyyy年M月d');

	if (temp === now.format('yyyy年M月d')) {
		return this.format('HH:mm');
	}
	if (this.getFullYear() === now.getFullYear()) {
		return this.format('M月d日');
	}
	return temp;
};

/**
 * description: 将一段时长转换成友好格式,如：147->“2分27秒” 1581->“26分21秒” 15818->“4小时24分”
 * @return {String} 返回格式化后的日期字符串
 * 
 * created by hezq on 2019-11-21
 */
Date.prototype.formatDurationToFriendly = function() {
	// 正整数规则
	if(!/^[1-9]+[0-9]*$/.test(this)){
		return '';
	}
	// 时间转化
	if (this < 60) {
		return this + '秒';
	} else if (this < 60 * 60) {
		return (this - this % 60) / 60 + '分' + this % 60 + '秒';
	} else if (this < 60 * 60 * 24) {
		return (this - this % 3600) / 60 / 60 + '小时' + Math.round(this % 3600 / 60) + '分';
	}
	return (this / 60 / 60 / 24).toFixed(1) + '天';
};

/**
 * description: 将时间转换成MM:SS形式 
 * @return {String} 返回格式化后的日期字符串
 * 
 * created by hezq on 2019-11-21
 */
Date.prototype.formatTimeToFriendly = function() {
	// 正整数规则
	if(!/^[1-9]+[0-9]*$/.test(this)){
		return '';
	}
	
	let m = Math.floor(this / 60);

	m = m < 10 ? '0' + m : m;
	let s = this % 60;

	s = s < 10 ? '0' + s : s;
	return m + ':' + s;
};

/**
 * description: 判断某一年是否是闰年
 * @return {Boolean} true-是 false-否
 * 
 * created by hezq on 2019-11-21
 */
Date.prototype.isLeapYear = function() {
	let date = this.getFullYear();
	return date % 4 === 0 && date % 100 !== 0 || date % 400 === 0;
};

/**
 * description: 获取某一年某一月的总天数
 * @param {Number} month 几月
 * @return {Number} 有几天
 * 
 * created by hezq on 2019-11-21
 */
Date.prototype.getMonthDays = function(month) {
	let y, m;

	y = this.getFullYear();
	m = this.getMonth();
	
	let days = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // 非闰年的一年中每个月份的天数
	//如果是闰年并且是2月

	if (m === 1 && this.isLeapYear()) {
		return days[m] + 1;
	}
	return days[m];
};

/**
 * description: 获取日期所在季度开始第一天及当前日期格式化
 * @return {Object} 开始-结束时间
 * 
 * created by hezq on 2019-11-21
 */
Date.prototype.getSeasonToNow = function() {
	let month = this.getMonth();
	let season = parseInt(month / 3) + 1;
	let seasonArr = ["01", "04", "07", "10"];

	return {
		start: this.getFullYear() + "-" + seasonArr[season - 1] + "-01",
		end: this.format('yyyy-MM-dd')
	};
};

/**
 * description: 获取日期所在年度开始第一天及当前日期格式化
 * @return {Object} 开始-结束时间
 * 
 * created by hezq on 2019-11-21
 */
Date.prototype.getYearToNow = function() {
	return {
		start: this.getFullYear() + "-01-01",
		end: this.format('yyyy-MM-dd')
	};
};

/**
 * description: 获取日期所在月度开始第一天及当前日期格式化
 * @return {Object} 开始-结束时间
 * 
 * created by hezq on 2019-11-21
 */
Date.prototype.getMonthToNow = function() {
	let month = this.getMonth() + 1;
	
	month = month > 9 ? month : "0" + month;
	return {
		start: this.getFullYear() + "-" + month + "-01",
		end: this.formatDate('yyyy-MM-dd')
	};
};

let dates = {};

/**
 * description: 获取当前时间的时间戳
 * @return {Number} 时间戳
 *
 * created by hezq on 2019-11-21
 *
 */
dates.getCurrentTimeStamp = function() {
	return (new Date()).getTime();
};

/**
 * description: 将日期格式化成指定格式的字符串
 * @param {String} fmt 目标字符串格式，支持的字符有：y,M,d,q,w,H,h,m,S，默认：yyyy-MM-dd HH:mm:ss
 * @return {String} 返回格式化后的日期字符串
 * 
 * created by hezq on 2019-11-26
 */
dates.format = function(date, fmt) {
	if(!date){
		return '';
	}
	date = typeof date === 'number' ? new Date(date) : date;
	if (typeof date === 'string') {
		if(date.includes(".")) {
			date = date.split(".")[0];
		}
		date = new Date(date.replace(/-/g, "/"));
	}
	fmt = fmt || 'yyyy-MM-dd HH:mm:ss';
	
	let obj = {
		'y': date.getFullYear(), // 年份，注意必须用getFullYear
		'M': date.getMonth() + 1, // 月份，注意是从0-11
		'd': date.getDate(), // 日期
		'q': Math.floor((date.getMonth() + 3) / 3), // 季度
		'w': date.getDay(), // 星期，注意是0-6
		'H': date.getHours(), // 24小时制
		'h': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // 12小时制
		'm': date.getMinutes(), // 分钟
		's': date.getSeconds(), // 秒
		'S': date.getMilliseconds() // 毫秒
	};
	let week = ['天', '一', '二', '三', '四', '五', '六'];

	for(let i in obj) {
		fmt = fmt.replace(new RegExp(i + '+', 'g'), function(m) {
			let val = String(obj[i]);

			if(i === 'w') {return(m.length > 2 ? '星期' : '周') + week[val];}
			for(let j = 0, len = val.length; j < m.length - len; j++) {val = '0' + val;}
			return m.length === 1 ? val : val.substring(val.length - m.length);
		});
	}
	return fmt;
};

/**
 * description: 计算2日期之间的天数，传进来的日期是yyyy-MM-dd格式的字符串日期
 * @param {String} sDate1 日期一 格式yyyy-MM-dd
 * @param {String} sDate2 日期二 格式yyyy-MM-dd
 * @return {Number} 差了几天
 * 
 * created by hezq on 2019-11-21
 * 
 */
dates.dateDiff = function(sDate1, sDate2) { 
	let aDate, oDate1, oDate2, iDays;

	aDate = sDate1.split("-");
	// 转换为MM-dd-yyyy格式  
	oDate1 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0]); 
	aDate = sDate2.split("-");
	oDate2 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0]);
	// 把相差的毫秒数转换为天数  
	iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24); 
	return iDays;
};

/**
 * description: 获取当前日期前的多少天存入数组
 * @param {Number} len 往前推多少天
 * @return {Array} 日期字符串数组
 * 
 * created by hezq on 2019-11-21
 * 
 */
dates.getLastDates = function(len) {
	let lastDays = [];

	for(let i = len - 1; i >= 0; i--) {
		let tmp = new Date().setDate(new Date().getDate() - i);
		let stmp = this.format("yyyy-MM-dd");

		lastDays.push(stmp);
	}
	return lastDays;
};

/**
 * description: 获取日期范围内的天数存入数组
 * @param {String} from 开始时间,格式yyyy-MM-dd
 * @param {String} to 结束时间,格式yyyy-MM-dd
 * @return {Array} 日期字符串数组
 * 
 * created by hezq on 2019-11-21
 * 
 */
dates.getDatesByFromTo = function(from, to) {
	let days = [];
	let length = dates.dateDiff(from, to) + 1;

	for(let i = length - 1; i >= 0; i--) {
		let tmp = new Date(to).setDate(new Date(to).getDate() - i);
		let stmp = this.format("yyyy-MM-dd");

		days.push(stmp);
	}
	return days;
};

export default dates;



// WEBPACK FOOTER //
// ./src/tools/date/index.js